import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Spinner } from 'components/UI/V3/Spinner/Spinner';
import { FunctionComponent } from 'react';
import { formatPayoutAmount } from 'utils/PaymentsUtils';
import InfoTooltip from './InfoTooltip';
import styles from './AvailableBalance.module.scss';

interface AvailableBalanceProps {
    amount: number | string;
    loading?: boolean;
    showPayoutNow?: boolean;
    onPayoutNow?: () => void;
}

export const AvailableBalance: FunctionComponent<AvailableBalanceProps> = ({
    amount,
    loading,
    showPayoutNow,
    onPayoutNow
}) => {
    return (
        <div className={clsx(styles.root, showPayoutNow && !loading && styles.withPayout)}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <p className={styles.title}>Available Balance</p>
                    <InfoTooltip
                        content="Your total balance, including settled funds and transactions that are still processing."
                        ariaLabel="Available Balance information"
                    />
                </div>
                {loading ? (
                    <div className={styles.spinner}>
                        <Spinner size={32} />
                    </div>
                ) : (
                    <span className={styles.amount}>{formatPayoutAmount(amount)}</span>
                )}
            </div>
            {showPayoutNow && !loading && (
                <button
                    type="button"
                    className={styles.payoutNow}
                    onClick={onPayoutNow}
                >
                    <span>Payout Now</span>
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        className={styles.chevron}
                    />
                </button>
            )}
        </div>
    );
};

export default AvailableBalance;
